import { deepMerge } from '../../utils/deepMerge';
const backgroundColorMapping = {
  /**
   * Overrides
   */
  calypso: 'fill-accent-blue-default',
  'candy-apple': 'fill-accent-red-default',
  koala: 'fill-accent-neutral-subtle-alt',
  lorax: 'fill-accent-orange-default',
  marigold: 'fill-caution-default',
  norman: 'fill-accent-magenta-default',
  oz: 'fill-accent-green-default',
  pantera: 'fill-accent-neutral-default',
  sorbet: 'fill-accent-light-orange-default',
  thunderdome: 'fill-accent-purple-default',
  /**
   * Custom
   */
  beta: 'fill-accent-purple-default',
  free: 'fill-accent-orange-default',
  new: 'fill-accent-green-default',
  blue: 'fill-accent-blue-subtle',
  teal: 'fill-accent-teal-subtle',
  'teal-dark': 'fill-accent-teal-default',
  green: 'fill-accent-green-subtle',
  yellow: 'fill-accent-yellow-subtle',
  orange: 'fill-accent-orange-subtle',
  magenta: 'fill-accent-magenta-subtle',
  purple: 'fill-accent-purple-subtle'
};
const addBorderRadiusCornerValue = ({
  theme,
  styles,
  borderRadiusKey,
  cornerRadius,
  borderRadius
}) => {
  // Default to the overall borderRadius if individual values are undefined
  const value = cornerRadius !== null && cornerRadius !== void 0 ? cornerRadius : borderRadius;
  if (value) {
    styles[borderRadiusKey] = theme.borderRadius[value];
  }
};
export const getBackgroundColorToken = use => {
  var _backgroundColorMappi;
  return (_backgroundColorMappi = backgroundColorMapping[use]) !== null && _backgroundColorMappi !== void 0 ? _backgroundColorMappi : 'fill-accent-orange-default';
};
export const getBadgeStyleOverrides = ({
  use,
  theme,
  borderRadius,
  borderStartStartRadius,
  borderStartEndRadius,
  borderEndStartRadius,
  borderEndEndRadius,
  badgeContext
}) => {
  var _badgeContext$badgeSt;
  const styles = {};
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderStartStartRadius',
    cornerRadius: borderStartStartRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderStartEndRadius',
    cornerRadius: borderStartEndRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderEndStartRadius',
    cornerRadius: borderEndStartRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderEndEndRadius',
    cornerRadius: borderEndEndRadius,
    borderRadius
  });
  return deepMerge(Object.assign({}, use !== 'count' ? styles : {}), (_badgeContext$badgeSt = badgeContext === null || badgeContext === void 0 ? void 0 : badgeContext.badgeStyleOverrides) !== null && _badgeContext$badgeSt !== void 0 ? _badgeContext$badgeSt : {});
};